import {

} from "../mutationTypes";

import {FETCH_SAMPLE_REQUEST} from "../mutationTypes";
import SampleApi from "@shared/_api/sample";
import {FETCH_SAMPLE_SUCCESS} from "../mutationTypes";
import {FETCH_SAMPLE_FAILED} from "../mutationTypes";
import * as normalizr from "normalizr";
import {ADD_SAMPLE_ITEM_REQUEST} from "../mutationTypes";
import {ADD_SAMPLE_ITEM_SUCCESS} from "../mutationTypes";
import {ADD_SAMPLE_ITEM_FAILED} from "../mutationTypes";
import {DELETE_SAMPLE_ITEM_REQUEST} from "../mutationTypes";
import {DELETE_SAMPLE_ITEM_SUCCESS} from "../mutationTypes";
import {DELETE_SAMPLE_ITEM_FAILED} from "../mutationTypes";
import {UPDATE_CART_ITEM_REQUEST} from "../mutationTypes";
import ShoppingCartApi from "@shared/_api/shoppingCart";
import {UPDATE_CART_ITEM_SUCCESS} from "../mutationTypes";
import {UPDATE_CART_ITEM_FAILED} from "../mutationTypes";
import {UPDATE_SAMPLE_ITEM_REQUEST} from "../mutationTypes";
import {UPDATE_SAMPLE_ITEM_SUCCESS} from "../mutationTypes";
import {UPDATE_SAMPLE_ITEM_FAILED} from "../mutationTypes";

const normalize = normalizr.normalize;
const schema = normalizr.schema;

const sampleCollectionEntity = new schema.Entity('collection');
const sampleItemEntity = new schema.Entity('collectionItem');

sampleCollectionEntity.define({
    sampleItemList: [sampleItemEntity]
});


const state = {
    entities: {
        sampleItemList: []
    },
    loadingSampleCollection: false,
    busyItemId: null
};

const actions = {
    fetchSampleList({commit, rootState}) {
        if(rootState.account.user) {
            commit(FETCH_SAMPLE_REQUEST);
            return SampleApi.get().then(sampleCollection => {
                commit(FETCH_SAMPLE_SUCCESS, normalize(sampleCollection, sampleCollectionEntity));
                return sampleCollection;
            }).catch(error => {
                commit(FETCH_SAMPLE_FAILED);
            })
        }
    },
    addSample({commit}, {item}) {
        commit(ADD_SAMPLE_ITEM_REQUEST);
        return SampleApi.add(item).then((sampleCollection) => {
            commit(FETCH_SAMPLE_SUCCESS, normalize(sampleCollection, sampleCollectionEntity));
            return sampleCollection;
        })
    },
    removeSample({commit}, {item}) {
        commit(DELETE_SAMPLE_ITEM_REQUEST, item);
        return SampleApi.remove(item.id).then(() => {
            commit(DELETE_SAMPLE_ITEM_SUCCESS, {item: item})
        }).catch(error => {
            commit(DELETE_SAMPLE_ITEM_FAILED, item);
        })
    },
    updateItem({commit}, {item}) {
        commit(UPDATE_SAMPLE_ITEM_REQUEST, item);
        return SampleApi.update(item).then(() => {
            commit(UPDATE_SAMPLE_ITEM_SUCCESS, item)
        }).catch(error => {
            commit(UPDATE_SAMPLE_ITEM_FAILED);
        })
    },
};

const getters = {
    sampleItemList: (state) => state.entities.sampleItemList,
    sampleCount: (state) => state.entities.sampleItemList ? Object.keys(state.entities.sampleItemList).length : 0
};

const mutations = {
    [FETCH_SAMPLE_SUCCESS](state, sampleCollectionNormalized) {
        Vue.set(state.entities, 'sampleItemList', sampleCollectionNormalized.entities.collectionItem);
        state.loadingSampleCollection = false;
    },
    [FETCH_SAMPLE_REQUEST](state) {
        state.entities = {
            sampleItemList: []
        };
        state.loadingSampleCollection = true;
    },
    [FETCH_SAMPLE_FAILED](state) {
        state.loadingSampleCollection = false;
    },
    [ADD_SAMPLE_ITEM_REQUEST](state) {
        state.loadingSampleCollection = true;
    },
    [ADD_SAMPLE_ITEM_SUCCESS](state) {
        state.loadingSampleCollection = true;
    },
    [ADD_SAMPLE_ITEM_FAILED](state) {
        state.loadingSampleCollection = false;
    },
    [DELETE_SAMPLE_ITEM_REQUEST](state, item) {
        state.busyItemId = item.id;
    },
    [DELETE_SAMPLE_ITEM_SUCCESS](state, {item}) {
        Vue.delete(state.entities.sampleItemList, item.id);
    },
    [DELETE_SAMPLE_ITEM_FAILED](state) {
        state.busyItemId = null;
    },
    [UPDATE_SAMPLE_ITEM_REQUEST](state, item) {
        state.busyItemId = item.id;
    },
    [UPDATE_SAMPLE_ITEM_SUCCESS](state, item) {
        Vue.set(state.entities.sampleItemList[item.id], item);
        state.busyItemId = null;
    },
    [UPDATE_SAMPLE_ITEM_FAILED](state, item) {
        state.busyItemId = null;
    }

};

export const sample = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
